export function createAction(type, payload, meta = {}) {
  let error = false;

  if (payload instanceof Error) {
    error = true;
  }

  return {
    error,
    meta,
    payload,
    type
  };
}

export function createSDKAction(type, payload, meta = {}) {
  return createAction(type, payload, { ...meta, apiRequest: true });
}

export function onFulfill(type) {
  return `${type}_FULFILLED`;
}

export function onPending(type) {
  return `${type}_PENDING`;
}

export function onReject(type) {
  return `${type}_REJECTED`;
}
